import { CountryData, OptionGroup, Option } from "./ProfileTypes";

export const profileSections = [
  { value: "personal", label: "Personal Information" },
  { value: "contact", label: "Contact Details" },
  { value: "education", label: "Education" },
  { value: "employment", label: "Employment" },
];

export const profileValidationRules = {
  firstName: { required: true, minLength: 2 },
  lastName: { required: true, minLength: 2 },
  email: { required: true, pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/ },
  phone: { required: true, minLength: 8 },
};

export const titleOptions = [
  { value: "Mr", label: "Mr" },
  { value: "Ms", label: "Ms" },
  { value: "Mrs", label: "Mrs" },
  { value: "Miss", label: "Miss" },
  { value: "Mx", label: "Mx" },
  { value: "Dr", label: "Dr" },
];

export const genderOptions = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
];

export const maritalStatusOptions = [
  { value: "Single", label: "Single" },
  { value: "Married", label: "Married" },
  { value: "Widowed", label: "Widowed" },
  { value: "Divorced", label: "Divorced" },
  { value: "Separated", label: "Separated" },
];

export const employmentStatusOptions = [
  { value: "employed_fulltime", label: "Employed Full-time" },
  { value: "employed_parttime", label: "Employed Part-time" },
  { value: "self_employed", label: "Self-employed" },
  { value: "unemployed", label: "Unemployed" },
  { value: "student", label: "Student" },
  { value: "retired", label: "Retired" },
];

export const courseReasonOptions = [
  { value: "to_get_a_job", label: "To get a job" },
  {
    value: "to_get_a_better_job_or_promotion",
    label: "To get a better job or promotion",
  },
  {
    value: "to_try_for_a_different_career",
    label: "To try for a different career",
  },
  {
    value: "to_develop_existing_business",
    label: "To develop existing business",
  },
  { value: "to_start_my_own_business", label: "To start my own business" },
  {
    value: "it_was_a_requirement_of_my_job",
    label: "It was a requirement of my job",
  },
  {
    value: "i_wanted_extra_skills_for_my_job",
    label: "I wanted extra skills for my job",
  },
  {
    value: "to_get_into_another_course_of_study",
    label: "To get into another course of study",
  },
  {
    value: "for_personal_interest_or_self_development",
    label: "For personal interest or self-development",
  },
];

export const gradeOptions = [
  { value: "A+", label: "A+" },
  { value: "A", label: "A" },
  { value: "A-", label: "A-" },
  { value: "B+", label: "B+" },
  { value: "B", label: "B" },
  { value: "B-", label: "B-" },
  { value: "C+", label: "C+" },
  { value: "C", label: "C" },
  { value: "C-", label: "C-" },
  { value: "D+", label: "D+" },
  { value: "D", label: "D" },
  { value: "E", label: "E" },
  { value: "F", label: "F" },
  { value: "N/A", label: "N/A" },
];

export const testOptions = [
  { value: "TOEFL", label: "TOEFL" },
  { value: "IELTS", label: "IELTS" },
  { value: "PTE", label: "PTE" },
  { value: "CAE", label: "CAE" },
  { value: "CPE", label: "CPE" },
];

export const englishTestRanges = {
  TOEFL: { min: 0, max: 120 },
  IELTS: { min: 0, max: 9 },
  PTE: { min: 10, max: 90 },
  CAE: { min: 160, max: 210 },
  CPE: { min: 180, max: 230 },
};

export const countryCodes: CountryData[] = [
  {
    value: "+1",
    label: "+1",
    country: "United States / Canada",
    hasAreaCode: true,
    region: "North America",
    stateLabel: "State/Province",
    postalLabel: "ZIP/Postal Code",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["US", "CA"],
  },
  {
    value: "+7",
    label: "+7",
    country: "Russia / Kazakhstan",
    hasAreaCode: true,
    region: "Europe",
    stateLabel: "Oblast/Region",
    postalLabel: "Postal Code",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["RU", "KZ"],
  },
  {
    value: "+20",
    label: "+20",
    country: "Egypt",
    hasAreaCode: true,
    region: "Africa",
    stateLabel: "Governorate",
    postalLabel: "Postal Code",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["EG"],
  },
  {
    value: "+27",
    label: "+27",
    country: "South Africa",
    hasAreaCode: true,
    region: "Africa",
    stateLabel: "Province",
    postalLabel: "Postal Code",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["ZA"],
  },
  {
    value: "+30",
    label: "+30",
    country: "Greece",
    hasAreaCode: true,
    region: "Europe",
    stateLabel: "Region",
    postalLabel: "Postal Code",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["GR"],
  },
  {
    value: "+31",
    label: "+31",
    country: "Netherlands",
    hasAreaCode: true,
    region: "Europe",
    stateLabel: "Province",
    postalLabel: "Postcode",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["NL"],
  },
  {
    value: "+32",
    label: "+32",
    country: "Belgium",
    hasAreaCode: true,
    region: "Europe",
    stateLabel: "Province",
    postalLabel: "Postal Code",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["BE"],
  },
  {
    value: "+33",
    label: "+33",
    country: "France",
    hasAreaCode: true,
    region: "Europe",
    stateLabel: "Region",
    postalLabel: "Code Postal",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["FR"],
  },
  {
    value: "+34",
    label: "+34",
    country: "Spain",
    hasAreaCode: true,
    region: "Europe",
    stateLabel: "Province",
    postalLabel: "Código Postal",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["ES"],
  },
  {
    value: "+36",
    label: "+36",
    country: "Hungary",
    hasAreaCode: true,
    region: "Europe",
    stateLabel: "County",
    postalLabel: "Postal Code",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["HU"],
  },
  {
    value: "+39",
    label: "+39",
    country: "Italy",
    hasAreaCode: true,
    region: "Europe",
    stateLabel: "Region",
    postalLabel: "CAP",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["IT"],
  },
  {
    value: "+41",
    label: "+41",
    country: "Switzerland",
    hasAreaCode: true,
    region: "Europe",
    stateLabel: "Canton",
    postalLabel: "Postal Code",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["CH"],
  },
  {
    value: "+43",
    label: "+43",
    country: "Austria",
    hasAreaCode: true,
    region: "Europe",
    stateLabel: "State",
    postalLabel: "Postal Code",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["AT"],
  },
  {
    value: "+44",
    label: "+44",
    country: "United Kingdom",
    hasAreaCode: true,
    region: "Europe",
    stateLabel: "County",
    postalLabel: "Postcode",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["GB"],
  },
  {
    value: "+45",
    label: "+45",
    country: "Denmark",
    hasAreaCode: true,
    region: "Europe",
    stateLabel: "Region",
    postalLabel: "Postal Code",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["DK"],
  },
  {
    value: "+46",
    label: "+46",
    country: "Sweden",
    hasAreaCode: true,
    region: "Europe",
    stateLabel: "County",
    postalLabel: "Postal Code",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["SE"],
  },
  {
    value: "+47",
    label: "+47",
    country: "Norway",
    hasAreaCode: true,
    region: "Europe",
    stateLabel: "County",
    postalLabel: "Postal Code",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["NO"],
  },
  {
    value: "+48",
    label: "+48",
    country: "Poland",
    hasAreaCode: true,
    region: "Europe",
    stateLabel: "Voivodeship",
    postalLabel: "Postal Code",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["PL"],
  },
  {
    value: "+49",
    label: "+49",
    country: "Germany",
    hasAreaCode: true,
    region: "Europe",
    stateLabel: "State",
    postalLabel: "Postleitzahl",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["DE"],
  },
  {
    value: "+51",
    label: "+51",
    country: "Peru",
    hasAreaCode: true,
    region: "South America",
    stateLabel: "Region",
    postalLabel: "Código Postal",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["PE"],
  },
  {
    value: "+52",
    label: "+52",
    country: "Mexico",
    hasAreaCode: true,
    region: "Central America",
    stateLabel: "State",
    postalLabel: "Código Postal",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["MX"],
  },
  {
    value: "+53",
    label: "+53",
    country: "Cuba",
    hasAreaCode: true,
    region: "Central America",
    stateLabel: "Province",
    postalLabel: "Postal Code",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["CU"],
  },
  {
    value: "+54",
    label: "+54",
    country: "Argentina",
    hasAreaCode: true,
    region: "South America",
    stateLabel: "Province",
    postalLabel: "Código Postal",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["AR"],
  },
  {
    value: "+55",
    label: "+55",
    country: "Brazil",
    hasAreaCode: true,
    region: "South America",
    stateLabel: "State",
    postalLabel: "CEP",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["BR"],
  },
  {
    value: "+56",
    label: "+56",
    country: "Chile",
    hasAreaCode: true,
    region: "South America",
    stateLabel: "Region",
    postalLabel: "Código Postal",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["CL"],
  },
  {
    value: "+57",
    label: "+57",
    country: "Colombia",
    hasAreaCode: true,
    region: "South America",
    stateLabel: "Department",
    postalLabel: "Código Postal",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["CO"],
  },
  {
    value: "+60",
    label: "+60",
    country: "Malaysia",
    hasAreaCode: true,
    region: "Asia-Pacific",
    stateLabel: "State",
    postalLabel: "Postcode",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["MY"],
  },
  {
    value: "+61",
    label: "+61",
    country: "Australia",
    hasAreaCode: true,
    region: "Asia-Pacific",
    stateLabel: "State/Territory",
    postalLabel: "Postcode",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["AU"],
  },
  {
    value: "+62",
    label: "+62",
    country: "Indonesia",
    hasAreaCode: true,
    region: "Asia-Pacific",
    stateLabel: "Province",
    postalLabel: "Postal Code",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["ID"],
  },
  {
    value: "+63",
    label: "+63",
    country: "Philippines",
    hasAreaCode: true,
    region: "Asia-Pacific",
    stateLabel: "Province",
    postalLabel: "ZIP Code",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["PH"],
  },
  {
    value: "+64",
    label: "+64",
    country: "New Zealand",
    hasAreaCode: true,
    region: "Asia-Pacific",
    stateLabel: "Region",
    postalLabel: "Postcode",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["NZ"],
  },
  {
    value: "+65",
    label: "+65",
    country: "Singapore",
    hasAreaCode: false,
    region: "Asia-Pacific",
    stateLabel: "",
    postalLabel: "Postal Code",
    hasState: false,
    postalBeforeCity: true,
    isoCodes: ["SG"],
  },
  {
    value: "+66",
    label: "+66",
    country: "Thailand",
    hasAreaCode: true,
    region: "Asia-Pacific",
    stateLabel: "Province",
    postalLabel: "Postal Code",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["TH"],
  },
  {
    value: "+81",
    label: "+81",
    country: "Japan",
    hasAreaCode: true,
    region: "Asia-Pacific",
    stateLabel: "Prefecture",
    postalLabel: "Postal Code",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["JP"],
  },
  {
    value: "+82",
    label: "+82",
    country: "South Korea",
    hasAreaCode: true,
    region: "Asia-Pacific",
    stateLabel: "Province",
    postalLabel: "Postal Code",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["KR"],
  },
  {
    value: "+84",
    label: "+84",
    country: "Vietnam",
    hasAreaCode: true,
    region: "Asia-Pacific",
    stateLabel: "Province",
    postalLabel: "Postal Code",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["VN"],
  },
  {
    value: "+86",
    label: "+86",
    country: "China",
    hasAreaCode: true,
    region: "Asia-Pacific",
    stateLabel: "Province",
    postalLabel: "Postal Code",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["CN"],
  },
  {
    value: "+90",
    label: "+90",
    country: "Turkey",
    hasAreaCode: true,
    region: "Middle East",
    stateLabel: "Province",
    postalLabel: "Postal Code",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["TR"],
  },
  {
    value: "+91",
    label: "+91",
    country: "India",
    hasAreaCode: true,
    region: "Asia-Pacific",
    stateLabel: "State/Union Territory",
    postalLabel: "PIN Code",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["IN"],
  },
  {
    value: "+92",
    label: "+92",
    country: "Pakistan",
    hasAreaCode: true,
    region: "Asia-Pacific",
    stateLabel: "Province",
    postalLabel: "Postal Code",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["PK"],
  },
  {
    value: "+94",
    label: "+94",
    country: "Sri Lanka",
    hasAreaCode: true,
    region: "Asia-Pacific",
    stateLabel: "Province",
    postalLabel: "Postal Code",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["LK"],
  },
  {
    value: "+233",
    label: "+233",
    country: "Ghana",
    hasAreaCode: true,
    region: "Africa",
    stateLabel: "Region",
    postalLabel: "Postal Code",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["GH"],
  },
  {
    value: "+234",
    label: "+234",
    country: "Nigeria",
    hasAreaCode: true,
    region: "Africa",
    stateLabel: "State",
    postalLabel: "Postal Code",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["NG"],
  },
  {
    value: "+254",
    label: "+254",
    country: "Kenya",
    hasAreaCode: true,
    region: "Africa",
    stateLabel: "County",
    postalLabel: "Postal Code",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["KE"],
  },
  {
    value: "+351",
    label: "+351",
    country: "Portugal",
    hasAreaCode: true,
    region: "Europe",
    stateLabel: "District",
    postalLabel: "Postal Code",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["PT"],
  },
  {
    value: "+352",
    label: "+352",
    country: "Luxembourg",
    hasAreaCode: true,
    region: "Europe",
    stateLabel: "",
    postalLabel: "Postal Code",
    hasState: false,
    postalBeforeCity: true,
    isoCodes: ["LU"],
  },
  {
    value: "+353",
    label: "+353",
    country: "Ireland",
    hasAreaCode: true,
    region: "Europe",
    stateLabel: "County",
    postalLabel: "Eircode",
    hasState: true,
    postalBeforeCity: false,
    isoCodes: ["IE"],
  },
  {
    value: "+354",
    label: "+354",
    country: "Iceland",
    hasAreaCode: true,
    region: "Europe",
    stateLabel: "",
    postalLabel: "Postal Code",
    hasState: false,
    postalBeforeCity: true,
    isoCodes: ["IS"],
  },
  {
    value: "+358",
    label: "+358",
    country: "Finland",
    hasAreaCode: true,
    region: "Europe",
    stateLabel: "Region",
    postalLabel: "Postal Code",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["FI"],
  },
  {
    value: "+420",
    label: "+420",
    country: "Czech Republic",
    hasAreaCode: true,
    region: "Europe",
    stateLabel: "Region",
    postalLabel: "Postal Code",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["CZ"],
  },
  {
    value: "+506",
    label: "+506",
    country: "Costa Rica",
    hasAreaCode: true,
    region: "Central America",
    stateLabel: "Province",
    postalLabel: "Postal Code",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["CR"],
  },
  {
    value: "+507",
    label: "+507",
    country: "Panama",
    hasAreaCode: true,
    region: "Central America",
    stateLabel: "Province",
    postalLabel: "Postal Code",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["PA"],
  },
  {
    value: "+673",
    label: "+673",
    country: "Brunei",
    hasAreaCode: false,
    region: "Asia-Pacific",
    stateLabel: "",
    postalLabel: "Postal Code",
    hasState: false,
    postalBeforeCity: true,
    isoCodes: ["BN"],
  },
  {
    value: "+679",
    label: "+679",
    country: "Fiji",
    hasAreaCode: false,
    region: "Asia-Pacific",
    stateLabel: "",
    postalLabel: "Postal Code",
    hasState: false,
    postalBeforeCity: true,
    isoCodes: ["FJ"],
  },
  {
    value: "+852",
    label: "+852",
    country: "Hong Kong",
    hasAreaCode: false,
    region: "Asia-Pacific",
    stateLabel: "",
    postalLabel: "Postal Code",
    hasState: false,
    postalBeforeCity: true,
    isoCodes: ["HK"],
  },
  {
    value: "+853",
    label: "+853",
    country: "Macau",
    hasAreaCode: false,
    region: "Asia-Pacific",
    stateLabel: "",
    postalLabel: "Postal Code",
    hasState: false,
    postalBeforeCity: true,
    isoCodes: ["MO"],
  },
  {
    value: "+880",
    label: "+880",
    country: "Bangladesh",
    hasAreaCode: true,
    region: "Asia-Pacific",
    stateLabel: "Division",
    postalLabel: "Postal Code",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["BD"],
  },
  {
    value: "+886",
    label: "+886",
    country: "Taiwan",
    hasAreaCode: true,
    region: "Asia-Pacific",
    stateLabel: "County",
    postalLabel: "Postal Code",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["TW"],
  },
  {
    value: "+965",
    label: "+965",
    country: "Kuwait",
    hasAreaCode: false,
    region: "Middle East",
    stateLabel: "",
    postalLabel: "Postal Code",
    hasState: false,
    postalBeforeCity: true,
    isoCodes: ["KW"],
  },
  {
    value: "+966",
    label: "+966",
    country: "Saudi Arabia",
    hasAreaCode: true,
    region: "Middle East",
    stateLabel: "Province",
    postalLabel: "Postal Code",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["SA"],
  },
  {
    value: "+971",
    label: "+971",
    country: "UAE",
    hasAreaCode: true,
    region: "Middle East",
    stateLabel: "Emirate",
    postalLabel: "Postal Code",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["AE"],
  },
  {
    value: "+972",
    label: "+972",
    country: "Israel",
    hasAreaCode: true,
    region: "Middle East",
    stateLabel: "District",
    postalLabel: "Postal Code",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["IL"],
  },
  {
    value: "+973",
    label: "+973",
    country: "Bahrain",
    hasAreaCode: false,
    region: "Middle East",
    stateLabel: "",
    postalLabel: "Postal Code",
    hasState: false,
    postalBeforeCity: true,
    isoCodes: ["BH"],
  },
  {
    value: "+974",
    label: "+974",
    country: "Qatar",
    hasAreaCode: false,
    region: "Middle East",
    stateLabel: "",
    postalLabel: "Postal Code",
    hasState: false,
    postalBeforeCity: true,
    isoCodes: ["QA"],
  },
  {
    value: "+977",
    label: "+977",
    country: "Nepal",
    hasAreaCode: true,
    region: "Asia-Pacific",
    stateLabel: "Province",
    postalLabel: "Postal Code",
    hasState: true,
    postalBeforeCity: true,
    isoCodes: ["NP"],
  },
];

export const phoneTypes = [
  { value: "mobile", label: "Mobile" },
  { value: "office", label: "Office" },
  { value: "home", label: "Home" },
];

export const countriesFlat: Option[] = (() => {
  const uniqueCountries = new Set<string>();
  countryCodes.forEach((cc) => {
    const countries = cc.country.split(" / ");
    countries.forEach((country) => uniqueCountries.add(country.trim()));
  });
  return Array.from(uniqueCountries)
    .sort()
    .map((country) => ({ value: country, label: country }));
})();

export const getGroupedCountryCodes = () => {
  const regions = [
    "Asia-Pacific",
    "Europe",
    "North America",
    "Middle East",
    "Africa",
    "South America",
    "Central America",
  ];

  return regions.map((region) => ({
    label: region,
    options: countryCodes.filter((country) => country.region === region),
  }));
};

export const getCountryByCode = (code: string) => {
  return countryCodes.find((country) => country.value === code);
};

export const getCountryDataByName = (countryName: string) => {
  return countryCodes.find(
    (cc) =>
      cc.country.toLowerCase().includes(countryName.toLowerCase()) ||
      countryName.toLowerCase().includes(cc.country.toLowerCase())
  );
};

export const getAddressStateLabel = (country: string): string => {
  const countryData = getCountryDataByName(country);
  return countryData?.stateLabel || "State/Province/Region";
};

export const getAddressPostalLabel = (country: string): string => {
  const countryData = getCountryDataByName(country);
  return countryData?.postalLabel || "Postal Code";
};

export const shouldShowAddressState = (country: string): boolean => {
  const countryData = getCountryDataByName(country);
  return countryData?.hasState !== false;
};

export const isAddressPostalBeforeCity = (country: string): boolean => {
  const countryData = getCountryDataByName(country);
  return countryData?.postalBeforeCity !== false;
};

export const countriesGrouped: OptionGroup[] = (() => {
  const regions = [
    "Asia-Pacific",
    "Europe",
    "North America",
    "Central America",
    "South America",
    "Middle East",
    "Africa",
  ];
  return regions.map((region) => ({
    label: region,
    options: countriesFlat.filter((country) => {
      const countryData = countryCodes.find((cc) =>
        cc.country.includes(country.value)
      );
      return countryData?.region === region;
    }),
  }));
})();

export const postalCodePatterns: Record<string, RegExp> = {
  "united states": /^\d{5}(-\d{4})?$/,
  canada: /^[A-Za-z]\d[A-Za-z] ?\d[A-Za-z]\d$/,
  "united kingdom": /^[A-Za-z]{1,2}\d[A-Za-z\d]? ?\d[A-Za-z]{2}$/,
  germany: /^\d{5}$/,
  france: /^\d{5}$/,
  australia: /^\d{4}$/,
  singapore: /^\d{6}$/,
  japan: /^\d{3}-?\d{4}$/,
  netherlands: /^\d{4} ?[A-Za-z]{2}$/,
  spain: /^\d{5}$/,
  italy: /^\d{5}$/,
  brazil: /^\d{5}-?\d{3}$/,
};

export const postalCodePlaceholders: Record<string, string> = {
  "united states": "12345 or 12345-6789",
  canada: "A1A 1A1",
  "united kingdom": "SW1A 1AA",
  germany: "12345",
  france: "12345",
  spain: "12345",
  italy: "12345",
  australia: "1234",
  singapore: "123456",
  japan: "123-4567",
  netherlands: "1234 AB",
  brazil: "12345-123",
};
